export default __webpack_public_path__ + "static/RivalAnalysis-bg-2fd9e7411219c958cccf763caba8a535.png";